<rt-dropdown>
  <rt-form-field
    *ngIf="searchEnabled"
    margin-lr-small-x
    margin-top-small-x
    variant="underlined search"
  >
    <rt-icon name="search"></rt-icon>
    <rt-input
      [autoFocus]="true"
      [formControl]="searchFormControl"
      placeholder="Search..."
      variant="underlined"
    ></rt-input>
  </rt-form-field>
  <div class="items-container">
    <rt-dropdown-item
      (click)="select(el)"
      (mouseenter)="onElementHover(index)"
      *ngFor="let el of data; trackBy: trackByMention; let index = index"
      [class.highlighted]="index === highlightedIndex"
      [hasHoverEffect]="false"
      class="cursor-pointer"
      variant="no-padding"
    >
      <div class="item">
        <rt-avatar
          [imageSrc]="el.avatar"
          size="small-x"
          shape="oval"
          type="image"
          margin-right-small-x
        ></rt-avatar>
        {{ el.name }}
      </div>
    </rt-dropdown-item>
  </div>
</rt-dropdown>
